import { DemoFan } from './demoFan';

/**
 * Station-specific companions
 * These are only available in Station mode
 */
export const stationCompanions: DemoFan[] = [
  {
    id: 'ce8718be-1851-4c48-b369-2c472b9a42f0',
    companion_id: 'ce8718be-1851-4c48-b369-2c472b9a42f0',
    avatar_id: 'febffd4b-db06-4088-ace4-74de79f5facd',
    slug: 'lina-patel-14k9nml0n0',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/febffd4b-db06-4088-ace4-74de79f5facd/ce8718be-1851-4c48-b369-2c472b9a42f0_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/febffd4b-db06-4088-ace4-74de79f5facd/ce8718be-1851-4c48-b369-2c472b9a42f0_profile_video.mp4',
    alias: 'Lina',
    alias_tag: 'lina',
    artist_alias: 'Lina',
    given_name: 'Lina Patel',
    capability: 'presentation',
    title: 'Journalism Expert',
    placeholder: 'Describe your presentation...',
    full_image_url:'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/febffd4b-db06-4088-ace4-74de79f5facd/bf8d9019-0f9b-40e6-8030-b7141c1afdb9_image.jpg'
  },
  {
    id: '7205966d-cbfa-4c0b-9c06-da2a0bc16b7a',
    companion_id: '7205966d-cbfa-4c0b-9c06-da2a0bc16b7a',
    avatar_id: '26a0fa23-81a5-43ca-9b09-cd74805258c0',
    slug: 'will-jones',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/26a0fa23-81a5-43ca-9b09-cd74805258c0/de8d8f6b-e9e8-4b02-8396-fa67b1f11763_1_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/26a0fa23-81a5-43ca-9b09-cd74805258c0/de8d8f6b-e9e8-4b02-8396-fa67b1f11763_1_profile_video.mp4',
    alias: 'Will',
    alias_tag: 'will',
    artist_alias: 'Will',
    given_name: 'Will Jones',
    capability: 'business',
    title: 'Business And Startup Growth',
    placeholder: 'Describe your business idea...',
    full_image_url: 'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/26a0fa23-81a5-43ca-9b09-cd74805258c0/c5353316-0a86-4ae8-9828-574d67f4bb6b_image.jpg'
  },
  {
    id: '6c6f9e92-c9e4-47d8-bc0d-d15efff94836',
    companion_id: '6c6f9e92-c9e4-47d8-bc0d-d15efff94836',
    avatar_id: 'f76b005f-c2ed-4e39-a8d8-046aaab1a621',
    slug: 'alex-foster-14k9nml3z2',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/f76b005f-c2ed-4e39-a8d8-046aaab1a621/6c6f9e92-c9e4-47d8-bc0d-d15efff94836_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/f76b005f-c2ed-4e39-a8d8-046aaab1a621/6c6f9e92-c9e4-47d8-bc0d-d15efff94836_profile_video.mp4',
    alias: 'Alex',
    alias_tag: 'alex',
    artist_alias: 'Alex',
    given_name: 'Alex Foster',
    capability: 'webpage',
    title: 'Web-Development Expert',
    placeholder: 'Describe your website...',
    full_image_url: 'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/f76b005f-c2ed-4e39-a8d8-046aaab1a621/7d45d4c5-907e-46b3-8f9f-665c38a92a42_image.jpg'
  },
  {
    id: '1bdb4761-c13b-4ed8-b3fd-746172e9f770',
    companion_id: '1bdb4761-c13b-4ed8-b3fd-746172e9f770',
    avatar_id: 'c41ef9ce-6e18-4f63-88b7-f26e17fb45e3',
    slug: 'sophie-nguyen-edgkel42nk',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/c41ef9ce-6e18-4f63-88b7-f26e17fb45e3/1bdb4761-c13b-4ed8-b3fd-746172e9f770_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/c41ef9ce-6e18-4f63-88b7-f26e17fb45e3/1bdb4761-c13b-4ed8-b3fd-746172e9f770_profile_video.mp4',
    alias: 'Sophie',
    alias_tag: 'sophie',
    artist_alias: 'Sophie',
    given_name: 'Sophie Nguyen',
    capability: 'designer',
    title: 'Design Expert',
    placeholder: 'Describe your design concept...',
    full_image_url: 'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/c41ef9ce-6e18-4f63-88b7-f26e17fb45e3/1626e862-fc70-43dd-b245-97778c2423c2_image.jpg'
  }
];
